import { useState } from 'react';

const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = `${name}=${value};${expires};path=/`;
};

const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
};

// Custom hook to use cookies
const useCookie = (
  cookieName: string
): [
  string | null,
  (value: string, days: number) => void,
  () => void,
  (expectedValue: string) => boolean
] => {
  const [cookie, setCookieState] = useState<string | null>(() => getCookie(cookieName));

  const updateCookie = (value: string, days: number): void => {
    setCookie(cookieName, value, days);
    setCookieState(value);
  };

  const removeCookie = (): void => {
    deleteCookie(cookieName);
    setCookieState(null);
  };

  const checkCookie = (expectedValue: string): boolean => {
    return cookie === expectedValue;
  };

  return [cookie, updateCookie, removeCookie, checkCookie];
};

export default useCookie;
